import React from 'react';
import PropTypes from 'prop-types';
import AutoComplete from 'material-ui/AutoComplete';
import FieldTitle from 'components/aor/FieldTitle';
import MenuItem from 'material-ui/MenuItem';
import PointOfInterestResult from 'components/form/InputFields/LocationInputField/PointOfInterestResult';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';

class RenderLocationInputField extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            choices: [],
            searchText: '',
        };
    }

    componentDidUpdate(prevProps) {
        const { input } = this.props;
        const { choices } = this.state;

        if (choices.length === 0) {
            if (prevProps.input.value !== input.value) {
                this.setState(() => {
                    return {
                        choices: [
                            {
                                address: input.value,
                                id: 'google-places-prefill',
                                name: input.value,
                                type: 'google-places',
                            },
                        ],
                        searchText: input.value,
                    };
                });
            }
        }
    }

    handleNewRequest = (chosenRequest, index) => {
        if (~index) {
            const { input } = this.props;
            const { choices } = this.state;

            const result = choices[index];

            input.onChange(result.id);

            this.setState({
                searchText: result.text,
            });
        }
    }

    fetchPointsOfInterest = (value) => {
        const payload = {
            name: `%${ value }%`,
            size: 12,
            sort_by: 'id',
            sort_direction: 'asc',
        };

        return apiClient
            .read(`${ config.getApiBaseUrl() }/points-of-interest`, payload)
            .then(function (response) {
                let results = [];

                response.results.slice(0, 5).forEach((result) => {
                    results.push({
                        address: result.address,
                        id: result.id,
                        text: result.name,
                        type: result.type,
                    });
                });

                return results;
            });
    }

    fetchData = (value) => {
        Promise.all([
            this.fetchPointsOfInterest(value),
        ]).then(([
            pointsOfInterest,
        ]) => {
            const results = [
                ...pointsOfInterest,
            ];

            return this.setState({
                choices: results,
            });
        });
    }

    handleUpdateInput = utils.debounce((searchText, choices, params) => {
        const { minLength, input } = this.props;

        // If the string of the source is not 'change' it will not continue.
        if (params.source !== 'change') {
            return;
        }

        // Remove whitespaces around the text.
        if (utils.isString(searchText)) {
            searchText.trim();
        }

        if (searchText.length <= minLength) {
            input.onChange(searchText);

            return this.setState({
                choices: [],
            });
        }

        // Check if the searchText already exists in the choices.
        const textExists = choices.filter(function (data) {
            return data.text === searchText;
        });

        // If the length of the array > 0, it will not continue.
        if (textExists.length) {
            return;
        }

        this.fetchData(searchText);
    }, this.props.debounceTime);

    renderMenuItem = function (choice) {
        if (choice.type === 'google-places') {
            return (
                <MenuItem key={ choice.id }>
                    { choice.text }
                </MenuItem>
            );
        }

        return (
            <MenuItem key={ choice.id }>
                <PointOfInterestResult result={ choice } />
            </MenuItem>
        );
    }

    render() {
        const {
            animated,
            filter,
            fullWidth,
            input,
            label,
            meta: { touched, error },
            openOnFocus,
            resource,
            style,
            translate,
        } = this.props;

        const {
            choices,
            searchText,
        } = this.state;

        const dataSource = utils.map(choices, (choice) => {
            return {
                text: choice.text,
                value: this.renderMenuItem(choice),
            };
        });

        return (
            <AutoComplete
                autoComplete={ input.name }
                animated={ animated }
                dataSource={ dataSource }
                dataSourceConfig={ this.dataSourceConfig }
                errorText={ touched && error }
                filter={ filter }
                floatingLabelText={ <FieldTitle label={ label } source={ input.name } resource={ resource } /> }
                fullWidth={ fullWidth }
                id={ input.name }
                onNewRequest={ this.handleNewRequest }
                onUpdateInput={ (searchText, dataSource, params) => {
                    this.handleUpdateInput(searchText, dataSource, params);
                } }
                hintText={ translate('components.autocomplete.hinttext') }
                menuStyle={ {
                    maxHeight: '500px',
                    width: '100%',
                    overflowY: 'auto',
                    touchAction: 'none',
                } }
                openOnFocus={ openOnFocus }
                searchText={ searchText }
                style={ style }
            />
        );
    }
}

RenderLocationInputField.defaultProps = {
    animated: true,
    dataSource: [],
    debounceTime: 500,
    filter: AutoComplete.noFilter,
    fullWidth: false,
    minLength: 2,
    openOnFocus: true,
};

RenderLocationInputField.propTypes = {
    animated: PropTypes.bool,
    debounceTime: PropTypes.number,
    filter: PropTypes.func,
    fullWidth: PropTypes.bool,
    input: PropTypes.object,
    label: PropTypes.string,
    meta: PropTypes.shape({
        error: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.string,
        ]),
        touched: PropTypes.bool,
    }),
    minLength: PropTypes.number,
    openOnFocus: PropTypes.bool,
    resource: PropTypes.string,
    style: PropTypes.object,
    translate: PropTypes.func,
};

export default translate(RenderLocationInputField);



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderLocationInputField.js